<div class="wrapper">
  <app-esri-map
    #projectMap
    (mapComponentLoaded)="onMapComponentLoaded($event)"
    (mapLoaded)="onMapLoaded($event)"
    class="project-map"
    id="projectMap"
  />
  @if (open3d.observed && volumeFeatureIndex !== null) {
    <button
      type="button"
      class="volume-3d-badge"
      id="survey-map-3d-badge"
      aria-label="View volume in 3D"
      (click)="$event.stopPropagation(); open3d.emit({ featureIndex: volumeFeatureIndex })"
    >3D</button>
  }
</div>
